


























































































































import { defineComponent, PropType, Ref, ref } from '@vue/composition-api';
import { EpigraphyLabelLink } from '@oare/types';
import InnerImageZoom from 'vue-inner-image-zoom';

export default defineComponent({
  components: {
    InnerImageZoom,
  },
  props: {
    imageLinks: {
      type: Array as PropType<EpigraphyLabelLink[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    maxSelect: {
      type: Number,
      default: 2,
    },
    sticky: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const selectedImages = ref([0]);
    const compressedImages: Ref<number[]> = ref([]);

    const compressImage = (selection: number) => {
      compressedImages.value.push(selection);
    };

    const expandImage = (selection: number) => {
      const indexToRemove = compressedImages.value.indexOf(selection);
      compressedImages.value.splice(indexToRemove, 1);
    };

    const getWidth = (src: string) => {
      const image = new Image();
      image.src = src;
      const heightRatio = (window.innerHeight * 0.55) / image.height;

      return (heightRatio * image.width + 1).toFixed(0);
    };

    const updateSelected = (selection: number[]) => {
      selectedImages.value = selection;
      compressedImages.value = [];
      if (selectedImages.value.length > props.maxSelect) {
        selectedImages.value.shift();
      }
    };

    const parseSide = (sideCode: string | number | null) => {
      switch (sideCode) {
        case 1:
          return 'obv.';
        case 2:
          return 'lo.e.';
        case 3:
          return 'rev.';
        case 4:
          return 'u.e.';
        case 5:
          return 'le.e.';
        case 6:
          return 'r.e.';
        case 'a':
          return 'Envelope Inner obv.';
        case 'b':
          return 'Envelope Inner lo.e.';
        case 'c':
          return 'Envelope Inner rev.';
        case 'd':
          return 'Envelope Inner u.e.';
        case 'e':
          return 'Envelope Inner le.e.';
        case 'f':
          return 'Envelope Inner r.e.';
        case 'x':
          return 'Fat Cross';
        case 'h':
          return 'Handcopy';
        case 8:
          return 'Unknown Side';
        case 9:
          return 'Unknown Edge';
        case null:
          return 'No side information';
        default:
          return sideCode;
      }
    };

    const parseView = (viewCode: string | null) => {
      switch (viewCode) {
        case 'u':
          return 'Upper (from above)';
        case 'd':
          return 'Direct';
        case 'l':
          return 'Lower';
        case 'i':
          return 'Inverted Direct';
        case 'h':
          return 'Inverted Upper';
        case 'j':
          return 'Inverted Lower';
        case 'z':
          return 'View for Scale';
        case 'n':
          return 'Emphasis on Name';
        case 's':
          return 'Seal Impression Focus';
        case 'fr':
          return 'From Right';
        case 'fl':
          return 'From Left';
        case 'cx':
          return 'Contextual';
        case 'du':
          return 'Detail Unspecified';
        case null:
          return 'No view information';
        default:
          return viewCode;
      }
    };

    return {
      selectedImages,
      compressedImages,
      updateSelected,
      parseSide,
      parseView,
      compressImage,
      expandImage,
      getWidth,
    };
  },
});
